module.exports = __webpack_public_path__ + "static/media/facebook-letter-logo.894e4c1f.svg";